module.exports = __webpack_public_path__ + "static/media/logo_nav.ac2b73df.png";